import { QButton, QIcon, QMenuItem } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { useCopilotAccess } from '../../../../../hooks/useCopilotAccess';

interface SummarizeButtonProps {
  documentCode: string;
  renderAs?: 'button' | 'menuItem';
}

export function SummarizeButton({
  documentCode,
  renderAs = 'button',
}: Readonly<SummarizeButtonProps>): JSX.Element | null {
  const hasCopilotAccess = useCopilotAccess();
  const { t } = useTranslation();
  const label = t('buttons.summarize');

  if (!hasCopilotAccess) {
    return null;
  }

  const handleClick = (): void => {
    window.dispatchEvent(
      new CustomEvent('ShowAssistant', {
        detail: {
          stateType: 'prompt',
          initialPrompt: t('documentActions.summarizeDocumentPrompt', {
            documentCode,
          }),
          autoSend: true,
        },
      }),
    );
  };

  if (renderAs === 'menuItem') {
    return (
      <QMenuItem
        icon={<QIcon iconName="QualioAI" />}
        data-cy="summarize-ai-menu-item"
        onClick={handleClick}
        fontSize="sm"
      >
        {label}
      </QMenuItem>
    );
  }

  return (
    <QButton
      variant="ghost"
      leftIcon="QualioAI"
      data-cy="summarize-ai-button"
      onClick={handleClick}
    >
      {label}
    </QButton>
  );
}
